import { authenticatedRequest } from './apiClient';
import { Profile } from '../lib/database.types';
import { ApiAdminStats } from '../types/api';

export interface UserWithDetails extends Profile {
  zones_count?: number;
}

export const fetchAllUsers = async (): Promise<{ users: UserWithDetails[]; error: string | null }> => {
  try {
    const data = await authenticatedRequest<UserWithDetails[]>('/admin/users');
    return { users: data || [], error: null };
  } catch (err) {
    return { users: [], error: err instanceof Error ? err.message : 'Failed to fetch users' };
  }
};

export const fetchPendingUsers = async (): Promise<{ users: UserWithDetails[]; error: string | null }> => {
  try {
    const data = await authenticatedRequest<UserWithDetails[]>('/admin/users/pending');
    return { users: data || [], error: null };
  } catch (err) {
    return { users: [], error: err instanceof Error ? err.message : 'Failed to fetch pending users' };
  }
};

export const updateUserStatus = async (
  userId: string,
  status: 'pending' | 'active' | 'suspended' | 'rejected'
): Promise<{ success: boolean; error: string | null }> => {
  try {
    await authenticatedRequest<UserWithDetails>(`/admin/users/${userId}/status`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    });
    return { success: true, error: null };
  } catch (err) {
    return { success: false, error: err instanceof Error ? err.message : 'Failed to update user status' };
  }
};

export const getUserStats = async (): Promise<{
  total: number;
  pending: number;
  active: number;
  suspended: number;
  rejected: number;
  error: string | null;
}> => {
  try {
    const data = await authenticatedRequest<ApiAdminStats>('/admin/stats');
    return { ...data, error: null };
  } catch (err) {
    return { total: 0, pending: 0, active: 0, suspended: 0, rejected: 0, error: err instanceof Error ? err.message : 'Failed to fetch stats' };
  }
};
